import { Actions, ActionId } from '../../../util/RequestAction';

export const unitListThunks = Actions('units', 'list');
export const unitListActionIds = ActionId('units', 'list');